import type { TrackingContext } from './types';

const GOOGLE_TAG_MANAGER_ID = __GOOGLE_TAG_MANAGER_ID__;

/**
 * Google Tag Manager tracks the *anonymous* funnel — the login, signup and
 * marketing-adjacent pages Hydra now owns. It is deliberately never loaded for
 * an authenticated session: in-app usage is measured through cdp-analytics and
 * FullStory instead.
 *
 * Ported from Journeys UI (`app/utils/tracking-scripts/google-tag-manager.ts`)
 * when Hydra became the shell that boots first. The environment gate matches
 * the other production-only integrations in this app (see `shouldSentryWork`
 * in `@/utils/sentry`).
 */
function isGoogleTagManagerEnvironment() {
  return ['production', 'prod-staging-1', 'prod-staging-2', 'standalone'].includes(__CIO_ENV__);
}

function shouldInject(context: TrackingContext) {
  return isGoogleTagManagerEnvironment() && !context.authenticated;
}

export const GoogleTagManagerHeadTag = {
  tag: 'script',
  id: 'google-tag-manager-head',
  content: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GOOGLE_TAG_MANAGER_ID}')`,

  inject(element: HTMLElement, context: TrackingContext) {
    if (shouldInject(context)) {
      document.head.appendChild(element);
    }
  },
};

export const GoogleTagManagerBodyTag = {
  tag: 'noscript',
  id: 'google-tag-manager-body',
  content: `<iframe src="https://www.googletagmanager.com/ns.html?id=${GOOGLE_TAG_MANAGER_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,

  inject(element: HTMLElement, context: TrackingContext) {
    if (shouldInject(context)) {
      // Insert as high up in the body tag as possible
      document.body.insertBefore(element, document.body.firstChild);
    }
  },
};
